import axios, { CancelToken, Method} from 'axios';
import camelcaseKeys from 'camelcase-keys';
import {getTimeZone} from './helpers';

// Sports Index Domain
export const baseSportsIndexDomain: string = process.env.REACT_APP_SPORTS_INDEX_DOMAIN_URL??''; // Sports Index url
export const baseDomainName: string|undefined = process.env.REACT_APP_WIDGET_SERVICE_URL; // Beck-end url
export const baseCdnUrl: string|undefined = process.env.REACT_APP_WIDGET_CDN_URL; // CDN url

// create an axios instance
const service = axios.create({
  baseURL: baseDomainName, // url = base url + request url
  timeout: 100000 // request timeout
});

service.interceptors.response.use(
  response => {
    return camelcaseKeys(response.data, {deep: true});
  }
);

export default function request(url: string, query?: object, cancelToken?: CancelToken, headers?: object, requestType?: Method) {
  const defaultHeaders = {
    'Siw-Site-Path': window.location.href.slice(0, 1000),
    'Siw-User-Time-Zone': getTimeZone(),
  };
  return service({
    url,
    params: query,
    cancelToken: cancelToken,
    headers: {...headers, ...defaultHeaders},
    method: requestType ?? 'GET'
  });
}
